<p-dialog
  modal="true"
  styleClass="atlas-dialog-m"
  position="top"
  [closable]="false" [(visible)]="show"
>
  <ng-template pTemplate="header">
    <h4>
      {{ 'coupons.search.add-a-coupon' | translate | ucfirst }}
    </h4>
  </ng-template>
  <div>
    <wl-profile-search-and-select (profileSelected)="navigateToLegacyCouponPage($event.ProfileId)"></wl-profile-search-and-select>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary mr-10" (click)="show = false">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
  </ng-template>
</p-dialog>
